import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import {catchError, filter, finalize, switchMap, take } from 'rxjs/operators';
import { AuthenticationService, InterceptorRefreshHeader } from '../services/authentication.service';
import { Router } from '@angular/router';
import { MessagesService } from '../services/messages.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authenticationService: AuthenticationService,public _router: Router,private mesg: MessagesService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
 
    req = this.addAuthenticationToken(req);

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error && error.status === 401) {
          console.log("Intercept", error);
         // 401 errors are most likely going to be because we have an expired token that we need to refresh.
          if (this.refreshTokenInProgress) {
            // If refreshTokenInProgress is true, we'll wait until refreshTokenSubject has a non-null value
            // which means the new token is ready and we can retry the request again
            if(error.error.msg == "Token has expired"){
              // If retrieving the token has
              localStorage.removeItem('currentUser');
              this.mesg.updateFlashMessage("La sesión expiró, ingresa de nuevo");
              this._router.navigateByUrl('/login');
            }
            return this.refreshTokenSubject.pipe(
              filter(result => result !== null),
              take(1),
              switchMap(() => next.handle(this.addAuthenticationToken(req)))
            );
          } else {
            
            if(error.error.msg == "session expired"){
              localStorage.removeItem('currentUser');
              this.mesg.updateFlashMessage("La sesión expiró, ingresa de nuevo");
              this._router.navigateByUrl('/login');
            }

            this.refreshTokenInProgress = true;

            // Set the refreshTokenSubject to null so that subsequent API calls will wait until the new token has been retrieved
            this.refreshTokenSubject.next(null);

            return this.refreshAccessToken.pipe(
              switchMap((success: boolean) => {
                this.refreshTokenSubject.next(success);
                return next.handle(this.addAuthenticationToken(req));
              }),
              // When the call to refreshToken completes we reset the refreshTokenInProgress to false
              // for the next time the token needs to be refreshed
              finalize(() => this.refreshTokenInProgress = false)
            );
          }
        } else {
          return throwError(error);
        }
      })
    );
  }

  private refreshAccessToken = this.authenticationService.refresh() as Observable<any>;

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    // If we do not have a token yet then we should not set the header.
    // Here we could first retrieve the token from where we store it.
    let currentUser = JSON.parse(localStorage.getItem('currentUser') || "{}");
    if (!currentUser && !currentUser.access) {
      return request;
    }
    // If you are calling an outside domain then do not add the token. 
    if (request.url.match(/get-notifications/)) {
      return request;
    }
    if (request.headers.has(InterceptorRefreshHeader)) {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${currentUser.refresh}`
      });
      request = request.clone({ headers:headers });
    }  else {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.access}`
        }
      });
    }
    return request
  }
}
